<template>
    <div :class="className">
        <ul class="cardList">
            <li v-for="(v, i) in listData" :key="i">
                <p :style="{
                    color: colorObj[v.name] ?colorObj[v.name]: '#333',
                }">
                    {{ v.name }}
                </p>
                <h5>{{ v.value }}</h5>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: "TopTips",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        colorObj: {
            type: Object,
            default: () => ({
                "高危": '#EC5453',
                "危险": '#FF9400',
                "警告": '#7895EA',
                "紧急": '#EC5453',
                "重要": '#FF9400',
                "一般": '#7895EA',
                "安全隐患": '#FA541C',
            })
        },
        className: {
            type: String,
            default: ""
        }
    },
}
</script>


<style lang="scss" scoped>
.cardList {
    width: 96%;
    height: 65px;
    margin: 0 auto;
    @include setFlexBetween;

    li {
        width: 25%;
        height: 100%;
        @include setFlexColumn;
        align-items: center;
        justify-content: center;

        p {
            color: #333333;
            font-weight: 500;
            margin-bottom: 5px;
        }

        h5 {
            font-size: 20px;
            color: #666666;
            font-weight: 500;
        }
    }
}
</style>